import {getLandingConfig, getLatestVersion} from '~/utils/tools';

window.versionTools = {
  getVersionList: (language) => Object.keys(getLandingConfig(language)),
  findLatestVersion: (language) => getLatestVersion(Object.keys(getLandingConfig(language)).filter((v) => v !== 'preview'))
};
